var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBurgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.499023,
    width: 52,
    height: 52,
    rx: 4,
    fill: "#176B87"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.7212 34.8888H12.2768C11.8053 34.8888 11.3531 35.0761 11.0197 35.4095C10.6863 35.7429 10.499 36.195 10.499 36.6665C10.499 37.138 10.6863 37.5902 11.0197 37.9236C11.3531 38.257 11.8053 38.4443 12.2768 38.4443H40.7212C41.1927 38.4443 41.6449 38.257 41.9783 37.9236C42.3117 37.5902 42.499 37.138 42.499 36.6665C42.499 36.195 42.3117 35.7429 41.9783 35.4095C41.6449 35.0761 41.1927 34.8888 40.7212 34.8888Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2768 17.1111H40.7212C41.1927 17.1111 41.6449 16.9238 41.9783 16.5904C42.3117 16.257 42.499 15.8048 42.499 15.3333C42.499 14.8618 42.3117 14.4096 41.9783 14.0762C41.6449 13.7428 41.1927 13.5555 40.7212 13.5555H12.2768C11.8053 13.5555 11.3531 13.7428 11.0197 14.0762C10.6863 14.4096 10.499 14.8618 10.499 15.3333C10.499 15.8048 10.6863 16.257 11.0197 16.5904C11.3531 16.9238 11.8053 17.1111 12.2768 17.1111Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7212 24.2223H12.2768C11.8053 24.2223 11.3531 24.4096 11.0197 24.743C10.6863 25.0764 10.499 25.5286 10.499 26.0001C10.499 26.4716 10.6863 26.9238 11.0197 27.2572C11.3531 27.5906 11.8053 27.7779 12.2768 27.7779H40.7212C41.1927 27.7779 41.6449 27.5906 41.9783 27.2572C42.3117 26.9238 42.499 26.4716 42.499 26.0001C42.499 25.5286 42.3117 25.0764 41.9783 24.743C41.6449 24.4096 41.1927 24.2223 40.7212 24.2223Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerMenu);
export default __webpack_public_path__ + "static/media/burger-menu.824d032e09a415430d85e59c96786e37.svg";
export { ForwardRef as ReactComponent };